import { proxy, useSnapshot } from "valtio";
var _ = require('lodash');

const initialAppState = {
  loaded: false,
  swloaded: false,
  standalone: null,
  installed: null,
  scope: null,
  notified: false,
}

export const appState = proxy(initialAppState);
export function useAppStateSnapshot() { return useSnapshot(appState)}
export const getAppState = () => {return appState};
export const getStateStandalone = () => {return appState.standalone};
export const setStateStandalone = (tf) => {return appState.standalone = tf};
export const getStateInstalled = () => {return appState.installed};
export const setStateInstalled = (tf) => {return appState.installed = tf};
export const getStateSWLoaded = () => {return appState.swloaded};
export const setStateSWLoaded = (tf) => {return appState.swloaded = tf};
export const getStateScope = () => {return appState.scope};
export const setStateScope = (s) => {return appState.scope = s};

export const updateAppState = (as) => { 
  appState.loaded = as.loaded;
  appState.swloaded = as.swloaded;
  appState.standalone = as.standalone;
  appState.installed = as.installed;
  appState.scope = as.scope;
  appState.notified = as.notified;
};

const initialTestState = {
  testMode: false, 
  demoMode: false,
}
export const testModeState = proxy(initialTestState);
export const getTestState = () => {return testModeState};
export const getTestMode = () => {return testModeState.testMode};
export const setTestMode = (tf) => {return testModeState.testMode = tf};
export const getDemoMode = () => {return testModeState.demoMode};
export const setDemoMode = (tf) => {return testModeState.demoMode = tf};
export const updateTestState = (ds) => { 
  testModeState.testMode = ds.testMode;
  testModeState.demoMode = ds.demoMode;
};

const initialHelpState = {
  show: false, 
  forWhat: null
}

export const helpState = proxy(initialHelpState);
export const getHelpState = () => {return helpState};
export const getHelpShow = () => {return helpState.show};
export const updateHelpState = (show, forWhat) => {
  helpState.show = show;
  helpState.forWhat = forWhat;
};
export const resetHelpState = () => {
  helpState.show = false;
  helpState.forWhat = null;
};
export function useHelpStateSnapshot() { return useSnapshot(helpState)}

const initialOnlineState = {
  online: false
}
export const onlineState = proxy(initialOnlineState);
export const getOnline = () => {return onlineState.online};
export const setOnline = (tf) => {return onlineState.online = tf};
export function useOnlineStateSnapshot() { return useSnapshot(onlineState)}

const initialUsersListState = {
  loaded: false,
  usersList: []
};

export const usersListState = proxy(initialUsersListState);
export const setUsersListLoaded = (tf) => {usersListState.loaded = tf};
export const getUsersList = () => {return usersListState.usersList};
export function useUsersListSnapshot() {
  return useSnapshot(usersListState);
}

export const updateUsersListState = (newState) => {
  usersListState.loaded = newState.loaded;
  usersListState.usersList = newState.usersList;
};

const initialUserState = {
  loaded: false,
  authenticated: false, 
  currentUser: {}, 
  currentUserId: null,
};

export const initialUser = {
  userId: null,
  dateCreated: null,
  dateUpdated: null,
  displayName: null,
  firstName: null,
  lastName: null,
  email: null,
  awakeTime: "6:00AM",
  bedTime: "10:00PM",
  superuser: false,
  registrationDate: null,
  registrationId: null
};


export const userState = proxy(initialUserState);

export const resetUserState = () => {
  userState.loaded = initialUserState.loaded;
  userState.authenticated = initialUserState.authenticated;
  userState.currentUser = initialUserState.currentUser;
  userState.currentUserId = initialUserState.currentUserId;
};

export const updateUserState = (newState) => {
  userState.loaded = newState.loaded;
  userState.authenticated = newState.authenticated;
  userState.currentUser = newState.currentUser;
  userState.currentUserId = newState.currentUserId;
};

export function useUserStateSnapshot() { return useSnapshot(userState); }

export const getCurrentUserId = () => {return userState.currentUserId};
export const getCurrentUserRegistrationId = () => {return userState.currentUser.registrationId};
export const getCurrentUserName = () => {return userState.currentUser.displayName};
export const getCurrentUserEmail = () => {return userState.currentUser.email};
export const getCurrentUserAwakeTime = () => {return userState.currentUser.awakeTime};
export const getCurrentUserBedTime = () => {return userState.currentUser.bedTime};
export const getCurrentUser = () => {return userState.currentUser};
export const getSuperuser = () => {return userState.currentUser.superuser};
export const setCurrentUser = (u) => {userState.currentUser = u};
export const setCurrentUserId = (u) => {userState.currentUserId = u};
export const setSuperuser = (tf) => {userState.currentUser.superuser = tf};

export const getUserStateLoaded = (l) => {return userState.loaded};
export const setUserStateLoaded = (l) => {userState.loaded = l};
export const resetAllLoaded = () => {
  medsState.loaded = false;
  medsHistoryState.loaded = false;
  prescriptionsState.loaded = false;
  conditionsState.loaded = false;
  supplementsState.loaded = false;
  ingredientsState.loaded = false;
};

const initialMedsState = {
  loaded: false, 
  loading: false,
  meds: [], 
};

export const medsState = proxy(initialMedsState);

export const resetMedsState = () => {
  medsState.loaded = initialMedsState.loaded;
  medsState.loading = initialMedsState.loading;
  medsState.meds = initialMedsState.meds;
};

export const updateMedsState = (newState) => {
  medsState.loaded = newState.loaded;
  medsState.loading = newState.loading;
  medsState.meds = newState.meds;
};

export function useMedsStateSnapshot() { return useSnapshot(medsState)}

export const setMedsLoading = (tf) => { medsState.loading = tf};
export const setMedsLoaded = (tf) => { medsState.loaded = tf};
export const getMedsLoaded = () => { return medsState.loaded };
export const setMeds = (m) => { medsState.meds = m};
export const getMeds = () => { return medsState.meds};
export function addMed(med) { 
  medsState.meds.push(med);
  return medsState.meds;
};
export function updateMed(med) { 
  medsState.meds.forEach((m) => {
    if (m.medicationId === med.medicationId)
    {
      m = med;
      return medsState.meds;
    }
  })
  return medsState.meds;
};
export function deleteMed(medId) { 
  var newMeds = [];
  medsState.meds.forEach((m) => {if (m.medicationId !== medId) newMeds.push(m);});
  medsState.meds = newMeds;
  return newMeds;
};

const initialMedsHistoryState = {
  loaded: false, 
  loading: false,
  medsHistory: [], 
};

export const medsHistoryState = proxy(initialMedsHistoryState);

export const resetMedsHistoryState = () => {
  medsHistoryState.loaded = initialMedsHistoryState.loaded;
  medsHistoryState.loading = initialMedsHistoryState.loading;
  medsHistoryState.medsHistory = initialMedsHistoryState.medsHistory;
};

export const updateMedsHistoryState = (newState) => {
  medsHistoryState.loaded = newState.loaded;
  medsHistoryState.loading = newState.loading;
  medsHistoryState.medsHistory = newState.medsHistory;
};

export function useMedsHistoryStateSnapshot() { return useSnapshot(medsHistoryState)}

export const setMedsHistoryLoading = (tf) => { medsHistoryState.loading = tf};
export const setMedsHistoryLoaded = (tf) => { medsHistoryState.loaded = tf};
export const getMedsHistoryLoaded = () => { return medsHistoryState.loaded };
export const setMedsHistory = (m) => { medsHistoryState.medsHistory = m};
export const getMedsHistory = () => { return medsHistoryState.medsHistory};
export function addMedsHistory(hist) { 
  medsHistoryState.medsHistory.unshift(hist);
  sortHistory();
  //console.log('addMedsHistory: ', hist);
  return medsHistoryState.medsHistory;
};

export function deleteMedsHistory(hid) { 
  const ix = medsHistoryState.medsHistory.findIndex(h => h.historyId === hid)
  medsHistoryState.medsHistory.splice(ix,1);
  return medsHistoryState.medsHistory;
};

export function deleteHistByMedId(mid) {
  medsHistoryState.medsHistory.forEach((h,ix) => {
    if (h.medicationId === mid){
      medsHistoryState.medsHistory.splice(ix,1);
    }
  })
  return medsHistoryState.medsHistory;
};

export function sortHistory() {
  medsHistoryState.medsHistory.sort((a, b) => {
    if (a.date < b.date) { return 1; }
    if (a.date > b.date) { return -1; }
    return 0;
    });
};

export const createMedsStep = {
  // these are processed in sequence
  name: 1,
  brand: 2,
  type: 3,
  form: 4,
  strength: 5,
  dosage: 6,
  often: 7,
  // these are processed as needed
  hourly: 10,
  daily: 11,
  everyndays: 12,
  weekly: 13,
  weekdays: 14,
  schedule: 15,
  search: 16,
  // this is the end game
  confirm: 20,
}

export const initialCreateMedsState = {
  step: 1,
  maxStep: 0,
  orangeId: 0,
  medicationId: '',
  userId: '',
  labelId: '',
  name: '',
  type: '',
  class: '',
  brand: '',
  strength: '',
  form: '',
  dosage: '',
  occurance: 0,
  often: '',
  oftenText: '',
  isPaused: false,
  withMeals: false,
  sortOrder: 99,
  schedule: []
};

export const medsCreateState = proxy(initialCreateMedsState);
export const resetMedsCreateState = (is) => {
  let initState = initialCreateMedsState;
  if (is) initState = is;
  const resetObj = _.cloneDeep(initState)
  Object.keys(resetObj).forEach((key) => {
    medsCreateState[key] = resetObj[key]
  })
}
export function useMedsCreateState() { return useSnapshot(medsCreateState)}

// Condition

const initialConditionsState = {
  loaded: false, 
  loading: false,
  conditions: [], 
};

export const conditionsState = proxy(initialConditionsState);

export const resetConditionsState = () => {
  conditionsState.loaded = initialConditionsState.loaded;
  conditionsState.loading = initialConditionsState.loading;
  conditionsState.conditions = initialConditionsState.conditions;
};

export const updateConditionsState = (newState) => {
  conditionsState.loaded = newState.loaded;
  conditionsState.loading = newState.loading;
  conditionsState.conditions = newState.conditions;
};

export function useConditionsStateSnapshot() { return useSnapshot(conditionsState)}

export const setConditionsLoading = (tf) => { conditionsState.loading = tf};
export const setConditionsLoaded = (tf) => { conditionsState.loaded = tf};
export const getConditionsLoaded = () => { return conditionsState.loaded };
export const setConditions = (m) => { conditionsState.conditions = m};
export const getConditions = () => { return conditionsState.conditions};
export function addCondition(cond) { 
  conditionsState.conditions.unshift(cond);
  return conditionsState.conditions;
  }
export function deleteCondition(cid) { 
  const ix = conditionsState.conditions.findIndex(c => c.id === cid)
  conditionsState.conditions.splice(ix,1);
  return conditionsState.conditions;
  }

// Ingredients

const initialIngredientsState = {
  loaded: false, 
  loading: false,
  ingredients: [], 
};

const initialCreateIngredientsState = {
  ingredientId: '',
  userId: '',
  uniiCode: '',
  medicationId: 0,
  DsldId: 0,
  labelId: 0,
  name: '',
  quantity: 0,
  unit: '',
  notes: ''
}

export const ingredientsState = proxy(initialIngredientsState);
export const ingredientsCreateState = proxy(initialCreateIngredientsState);
export const resetIngredientsCreateState = (is) => {
  let initState = initialCreateIngredientsState;
  if (is) initState = is;
  const resetObj = _.cloneDeep(initState)
  Object.keys(resetObj).forEach((key) => {
    ingredientsCreateState[key] = resetObj[key]
  })
}
export function useIngredientsCreateState() { return useSnapshot(ingredientsCreateState)}

export const resetIngredientsState = () => {
  ingredientsState.loaded = initialIngredientsState.loaded;
  ingredientsState.loading = initialIngredientsState.loading;
  ingredientsState.ingredients = initialIngredientsState.ingredients;
};

export const updateIngredientsState = (newState) => {
  ingredientsState.loaded = newState.loaded;
  ingredientsState.loading = newState.loading;
  ingredientsState.ingredients = newState.ingredients;
};

export function useIngredientsStateSnapshot() { return useSnapshot(ingredientsState)}

export const setIngredientsLoading = (tf) => { ingredientsState.loading = tf};
export const setIngredientsLoaded = (tf) => { ingredientsState.loaded = tf};
export const getIngredientsLoaded = () => { return ingredientsState.loaded };
export const setIngredients = (m) => { ingredientsState.ingredients = m};
export const getIngredients = () => { return ingredientsState.ingredients};
export function addIngredient(i) { 
  ingredientsState.ingredients.push(i);
  return ingredientsState.ingredients;
  }
export function deleteIngredient(id) { 
  const ix = ingredientsState.ingredients.findIndex(h => h.id === id)
  ingredientsState.ingredients.splice(ix,1);
  return ingredientsState.ingredients;
  }

export function deleteIngredientsByMedId(mid) {

  }

export function updateIngredient(ing) { 
  console.log('updateIngredient', ing);
  for ( let j=0; j < ingredientsState.ingredients.length; ++j ) {
    if (ingredientsState.ingredients[j].id === ing.id)
    {
      ingredientsState.ingredients[j] = ing;
      console.log('Ingredient updated', ingredientsState.ingredients)
      return ingredientsState.ingredients;
    }
  }
  return ingredientsState.ingredients;
}
  
  // Supplements

  const initialSupplementsState = {
    loaded: false, 
    loading: false,
    supplements: [], 
  };
  
  
  const initialCreateSupplementsState = {
    id: 0,
    supplementId: '',
    userId: '',
    name: '',
    brand: '',
    contents: '',
    quantity: 0,
    unit: '',
    servingSize: 0,
    entryDate: '',
    sku: ''
  }
  
  export const supplementsState = proxy(initialSupplementsState);
  export const supplementsCreateState = proxy(initialCreateSupplementsState);
  export const resetSupplementsCreateState = (is) => {
    let initState = initialCreateSupplementsState;
    if (is) initState = is;
    const resetObj = _.cloneDeep(initState)
    Object.keys(resetObj).forEach((key) => {
      supplementsCreateState[key] = resetObj[key]
    })
  }
  export function useSupplementsCreateState() { return useSnapshot(supplementsCreateState)}
  
  export const resetSupplementsState = () => {
    supplementsState.loaded = initialSupplementsState.loaded;
    supplementsState.loading = initialSupplementsState.loading;
    supplementsState.supplements = initialSupplementsState.supplements;
  };
  
  export const updateSupplementsState = (newState) => {
    supplementsState.loaded = newState.loaded;
    supplementsState.loading = newState.loading;
    supplementsState.supplements = newState.supplements;
  };

  export function useSupplementsStateSnapshot() { return useSnapshot(supplementsState)}
  
  export const setSupplementsLoading = (tf) => { supplementsState.loading = tf};
  export const setSupplementsLoaded = (tf) => { supplementsState.loaded = tf};
  export const getSupplementsLoaded = () => { return supplementsState.loaded };
  export const setSupplements = (m) => { supplementsState.supplements = m};
  export const getSupplements = () => { return supplementsState.supplements};
  export function addSupplement(i) { 
    supplementsState.supplements.push(i);
    return supplementsState.supplements;
    }
  export function deleteSupplement(id) { 
    const ix = supplementsState.supplements.findIndex(h => h.id === id)
    supplementsState.supplements.splice(ix,1);
    return supplementsState.supplements;
    }
  
  export function deleteSupplementsByMedId(mid) {
  
    }
  
  export function updateSupplement(sup) { 
    console.log('updateSupplement', sup);
    for ( let j=0; j < supplementsState.supplements.length; ++j ) {
      if (supplementsState.supplements[j].id === sup.id)
      {
        supplementsState.supplements[j] = sup;
        console.log('Supplement updated', supplementsState.supplements)
        return supplementsState.supplements;
      }
    }
    return supplementsState.supplements;
  }

// Prescriptions

const initialPrescriptionsState = {
  loaded: false, 
  loading: false,
  prescriptions: [], 
};

export const prescriptionsState = proxy(initialPrescriptionsState);

export const resetPrescriptionsState = () => {
  prescriptionsState.loaded = initialPrescriptionsState.loaded;
  prescriptionsState.loading = initialPrescriptionsState.loading;
  prescriptionsState.prescriptions = initialPrescriptionsState.prescriptions;
};

export const updatePrescriptionsState = (newState) => {
  prescriptionsState.loaded = newState.loaded;
  prescriptionsState.loading = newState.loading;
  prescriptionsState.prescriptions = newState.prescriptions;
};

export function usePrescriptionsStateSnapshot() { return useSnapshot(prescriptionsState)}

export const setPrescriptionsLoading = (tf) => { prescriptionsState.loading = tf};
export const setPrescriptionsLoaded = (tf) => { prescriptionsState.loaded = tf};
export const getPrescriptionsLoaded = () => { return prescriptionsState.loaded };
export const setPrescriptions = (m) => { prescriptionsState.prescriptions = m};
export const getPrescriptions = () => { return prescriptionsState.prescriptions};
export function addPrescription(p) { 
  prescriptionsState.prescriptions.unshift(p);
  return prescriptionsState.prescriptions;
  }
export function deletePrescription(pid) { 
  const ix = prescriptionsState.prescriptions.findIndex(p => p.prescriptionId === pid)
  prescriptionsState.prescriptions.splice(ix,1);
  return prescriptionsState.prescriptions;
  }

